export default (speed = 50) => ({
  init() {
    const handleScroll = () => {
      const section = this.$el
      const parallaxImage = this.$refs.parallaxImage

      if (!parallaxImage) return

      const rect = section.getBoundingClientRect()
      const scrolled = window.scrollY
      const sectionTop = scrolled + rect.top
      const sectionHeight = section.offsetHeight
      const windowHeight = window.innerHeight

      if (rect.top < windowHeight && rect.bottom > 0) {
        const scrollPosition = scrolled - sectionTop + windowHeight
        const scrollRange = windowHeight + sectionHeight
        const scrollPercent = scrollPosition / scrollRange

        const translateY = (scrollPercent - 0.5) * (speed * 2)

        parallaxImage.style.transform = `translate3d(0, ${translateY}%, 0)`
      }
    }

    const rafHandleScroll = () => {
      requestAnimationFrame(handleScroll)
    }

    window.addEventListener('scroll', rafHandleScroll, { passive: true })
    window.addEventListener('resize', rafHandleScroll, { passive: true })

    handleScroll()

    this.$el._cleanup = () => {
      window.removeEventListener('scroll', rafHandleScroll)
      window.removeEventListener('resize', rafHandleScroll)
    }
  },

  destroy() {
    if (this.$el._cleanup) {
      this.$el._cleanup()
    }
  }
})
